import { EExchangeActions, IExchangeAction, IExchangeState } from "./types";

export const appReducer = (prevState: IExchangeState, action: IExchangeAction): IExchangeState => {
  switch (action.type) {
    case EExchangeActions.SET_ACTIVE_INTERVAL:
      return {
        ...prevState,
        activeInterval: action.payload.activeInterval,
      };
    case EExchangeActions.SET_ASSET_CHANGE_SCOPE:
      return {
        ...prevState,
        assetChangeScope: action.payload.assetChangeScope,
      };
    case EExchangeActions.SET_DISPLAY_ELEMENTS:
      return {
        ...prevState,
        displayElements: action.payload.displayElements,
      };
    case EExchangeActions.SET_TRANSACTION_ERROR_MESSAGE:
      return {
        ...prevState,
        transactionErrorMessage: action.payload.transactionErrorMessage,
      };
    case EExchangeActions.SET_TRANSACTION_ERROR_HANDLER:
      return {
        ...prevState,
        transactionErrorHandler: action.payload.transactionErrorHandler,
      };
    case EExchangeActions.SET_TRANSACTION_ERROR_ACTIONS:
      return {
        ...prevState,
        transactionErrorActions: action.payload.transactionErrorActions,
      };
    case EExchangeActions.SET_FORMATTED_LIMIT_VALUE:
      return {
        ...prevState,
        formattedLimitValue: action.payload.formattedLimitValue,
      };
    case EExchangeActions.SET_FORMATTED_VALUE_ASSET_A:
      return {
        ...prevState,
        formattedValueAssetA: action.payload.formattedValueAssetA,
      };
    case EExchangeActions.SET_FORMATTED_VALUE_ASSET_B:
      return {
        ...prevState,
        formattedValueAssetB: action.payload.formattedValueAssetB,
      };
    case EExchangeActions.SET_OUTPUT_EXCEEDS_RESERVE:
      return {
        ...prevState,
        outputExceedsReserve: action.payload.outputExceedsReserve,
      };
    case EExchangeActions.SET_IS_ASSET_CONSENT_CHECKED:
      return {
        ...prevState,
        isAssetConsentChecked: action.payload.isAssetConsentChecked,
      };
    case EExchangeActions.SET_IS_INSUFFICIENT_A:
      return {
        ...prevState,
        isInsufficientAssetA: action.payload.isInsufficientAssetA,
      };
    case EExchangeActions.SET_IS_INSUFFICIENT_B:
      return {
        ...prevState,
        isInsufficientAssetB: action.payload.isInsufficientAssetB,
      };
    case EExchangeActions.SET_IS_REMAINING_ADA_BELOW_THRESHOLD:
      return {
        ...prevState,
        isRemainingAdaAmountBelowThreshold: action.payload.isRemainingAdaAmountBelowThreshold,
      };
    case EExchangeActions.SET_LIMIT_VALUE:
      return {
        ...prevState,
        limitValue: action.payload.limitValue,
      };
    case EExchangeActions.SET_PARITY:
      return {
        ...prevState,
        parity: action.payload.parity,
      };
    case EExchangeActions.SET_SWAP_OUTCOME:
      return {
        ...prevState,
        swapOutcome: action.payload.swapOutcome,
      };
    case EExchangeActions.SET_TRADE_WARNING:
      return {
        ...prevState,
        tradeWarning: action.payload.tradeWarning,
      };
    case EExchangeActions.SET_TRANSACTION_BUILDER_BUILT_TX:
      return {
        ...prevState,
        transactionBuilderBuiltTx: action.payload.transactionBuilderBuiltTx,
      };
    case EExchangeActions.SET_TRANSACTION_BUILDER_COMPLETE_TX:
      return {
        ...prevState,
        transactionBuilderCompleteTx: action.payload.transactionBuilderCompleteTx,
      };
    case EExchangeActions.SET_TRANSACTION_BUILDER_STATE:
      return {
        ...prevState,
        transactionBuilderState: action.payload.transactionBuilderState,
      };
    case EExchangeActions.SET_VALUE_ASSET_A:
      return {
        ...prevState,
        valueAssetA: action.payload.valueAssetA,
      };
    case EExchangeActions.SET_VALUE_ASSET_B:
      return {
        ...prevState,
        valueAssetB: action.payload.valueAssetB,
      };
    case EExchangeActions.SET_CURRENT_PAGE:
      return {
        ...prevState,
        page: action.payload.page,
      };
    case EExchangeActions.INCREASE_PAGE:
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    default:
      throw new Error("No action was found!");
  }
};
